import { __assign } from "tslib";
import React, { Suspense } from 'react';
import { themes } from '../../ThemeOptions';
import Skeletons from './Skeleton';
var loading = function (ioMode, ioTheme, styleName) {
    return React.createElement(Skeletons, { count: 1, ioMode: ioMode, ioTheme: ioTheme, styleName: styleName });
};
var BootStrapToggle = React.lazy(function () {
    return import('../../bootstrap-components/components/BTReactToggleSwitch');
});
var bootStrapToggle = function (props) {
    return (React.createElement(BootStrapToggle, __assign({}, props)));
};
var ReactToggleSwitch = function (props) {
    var componentToDisplay;
    switch (props.ioTheme.uiLibrary) {
        case 'materialui':
            componentToDisplay = bootStrapToggle(props);
            break;
        default:
            componentToDisplay = bootStrapToggle(props);
            break;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Suspense, { fallback: loading(props.ioMode, props.ioTheme, props.styleName) }, componentToDisplay)));
};
ReactToggleSwitch.defaultProps = {
    styleName: 'primary',
    ioTheme: themes[0],
    ioMode: 'light',
    active: true,
};
export default React.memo(ReactToggleSwitch);
//# sourceMappingURL=ReactToggleSwitch.js.map